import { Mob } from "../mob";
import type { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { DummyMobCorpse } from "./dummyMobCorpse";

/**
 * Inert mob that never acts. Not spawned in normal gameplay — used as a stable,
 * predictable target for tests and the playground level.
 */
export class DummyMob extends Mob {
	static key = "DummyMob";

	constructor(xy: XY) {
		super(xy);
	}

	processMobAction(): void {}

	generateCorpse(): PhysicalThing | null {
		return new DummyMobCorpse(this.xy);
	}

	static deserialize(data: any): DummyMob {
		const mob = new DummyMob(deserializeXY(data.xy));
		mob.restoreMobFields(data);
		return mob;
	}
}
